<template>
  <div>
    <el-badge :value="alertCount">
      <el-button type="text" icon="fa-solid fa-bell" style="padding: 0 !important;font-size: 2rem;color:orange"
        @click="showModal = true; getAlert();">
      </el-button>
    </el-badge>
    <div>
      <el-dialog :title="$t('Gecikmələr')" @close="closeDialog()" :visible.sync="showModal" width="40%" top="5vh" append-to-body>
        <div v-for="statusTypeId in alerttypes" v-bind:key="statusTypeId"
          style="overflow: hidden; margin-bottom: 20px;margin-right: 10px;">
          <alert-badge :id="statusTypeId" :title="alertTitle(statusTypeId)" :alertType="alertStyle(statusTypeId)"
            :data="alert.filter((c) => c.statusTypeId === statusTypeId)"
            :count="alert.filter((c) => c.statusTypeId === statusTypeId).length" @click="clickBadge" />
        </div>
        <transition name="el-fade">
          <div v-show="showAlert">
            <alert :readonly="stage === 1 ? true : false" :pathname="pathName" ref="alertPanel" @close="closeBadge" />
          </div>
        </transition>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Alert from "../components/Alert.vue";
import AlertBadge from "../components/AlertBadge.vue";
import { AccidentStatusAlert } from "src/services/common";

export default {
  mounted() {
    this.getAlert();
  },
  components: {
    Alert,
    AlertBadge,
  },
  computed: {
    pathName() {
      if (this.$route.matched[0].path === '/act') return '/servicecenter'
      if (this.$route.matched[0].path === '/approval') return '/servicecenter'
      return this.$route.matched[0].path;
    },
    stage() {
      return this.$route.meta.stage;
    },
    alertCount() {
      return this.alert.filter(m => m.stage === this.stage).length
    },
  },
  data() {
    return {
      showModal: false,
      alert: [],
      alerttypes: [],
      showAlert: false
    };
  },
  methods: {
    getAlert() {
      AccidentStatusAlert().then((response) => {
        if (response.data.data) {
          this.alert = response.data.data;
          this.alerttypes = [
            ...new Set(
              response.data.data
                .filter((c) => c.stage === this.stage)
                .map((item) => item.statusTypeId)
            ),
          ];
        }
      });
    },
    closeDialog() {
      this.closeBadge();
    },
    clickBadge(val) {
      let reg = this.alert.filter((c) => c.statusTypeId === val);
      this.$refs.alertPanel.data = reg;
      this.$refs.alertPanel.statusTypeId = this.alertStyle(val);
      this.showAlert = true;
    },
    closeBadge() {
      this.showAlert = false;
      this.$refs.alertPanel.data = [];
    },
    alertTitle(val) {
      switch (val) {
        case 1:
          return "Qəza komissarına ötürülməyib";
        case 5:
          return "İş qəbul olunmayıb";
        case 10:
          return "Müştəri xidmətinə ötürülməyib";
        case 11:
          return "QK rəhbərinə təsdiqə göndərilib";
        case 12:
          return "QK təyinatı ləğv edib";
        case 13:
          return "QK Tələbdən imtina edib";
        case 14:
          return "QK rəhbəri hadisəni geri qaytarıb";
        case 30:
          return "İş qəbul olunmayıb";
        case 35:
          return "Məsul şəxs təyin olunmayıb";
        case 40:
          return "İş yaradılmayıb";
        case 45:
          return "DYP sənədləri hazır deyil";
        case 50:
          return "İş texniki ekspertizaya ötürülməyib";
        case 70:
          return "Məsul şəxs təyin olunmayıb";
        case 75:
          return "Daxili qiymətləndirmə başlanmayıb";
        case 80:
          return "Daxili qiymətləndirmə təsdiqə göndərilməyib";
        case 85:
          return "Daxili qiymətləndirmə razılaşdırılmağa göndərilməyib";
        case 90:
          return "Daxili qiymətləndirmənin qərarı verilməyib";
        case 95:
          return "T/M qiymətləndirmə göndərilməyib";
        case 100:
          return "T/M qiymətləndirmə razılaşdırılmağa göndərilməyib";
        case 105:
          return "T/M qiymətləndirmənin qərarı verilməyib";
        case 110:
          return "Təmir başlamayıb";
        case 115:
          return "M/E qiymətləndirmə razılaşdırılmağa göndərilməyib";
        case 120:
          return "M/E qiymətləndirmənin qərarı verilməyib";
        case 125:
          return "Qiymət razılaşdırılmayıb";
        case 130:
          return "Təmir yekunlaşmayıb";
        case 131:
          return "Müştəri xidmətinə göndərilməyib - Təmir";
        case 135:
          return "Müştəri xidmətinə göndərilməyib  - Razılaşma";
        case 145:
          return "Məsul şəxs təyin olunmayıb";
        case 146:
          return "Aktlaşdırma başlanmayıb";
        case 150:
          return "Təsdiqlənməyə göndərilməyib";
        case 151:
          return "Təsdiqə göndərilib";
        case 160:
          return "Ödənişə başlanmayıb";
        case 161:
          return "Ödəniş olunmayıb";
      }
    },
    alertStyle(val) {
      switch (val) {
        case 1:
          return "#FFA500";
        case 5:
          return "#FF7F50";
        case 10:
          return "#643843";
        case 11:
          return "#FFA500";
        case 12:
          return "#FF0000"
        case 13:
          return "#800000"
        case 14:
          return "#B3005E"
        case 30:
          return "#FF7F50";
        case 35:
          return "#DAA520";
        case 40:
          return "#A52A2A";
        case 45:
          return "#E9967A";
        case 50:
          return "#FFA500";
        case 70:
          return "#B22222";
        case 75:
          return "#FF0000";
        case 80:
          return "#FF8C00";
        case 85:
          return "#808000";
        case 90:
          return "#FFD700";
        case 95:
          return "#008000";
        case 100:
          return "#228B22";
        case 105:
          return "#00FF00";
        case 110:
          return "#0000CD";
        case 115:
          return "#A52A2A";
        case 120:
          return "#ADFF2F";
        case 125:
          return "#FF7F50";
        case 130:
          return "#E9967A";
        case 131:
          return "#4B0082";
        case 135:
          return "#6495ED";
        case 145:
          return "#B22222";
        case 146:
          return "#FF0000";
        case 150:
          return "#FF8C00";
        case 151:
          return "#FFA500";
        case 161:
          return "#FF8C00";
        case 162:
          return "#E9967A";
        default:
          return "#808080";

      }
    },
  },
};
</script>

<style scoped></style>